import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import TruncateFieldView from '../../../helpers/truncateFieldView';
import { ClientColumn, clientCost, ClientLoggedHours, clientRevenue, ClientRoi, clientTotalCost, ClientTotalCost, clientTotalRevenue, ClientTotalRevenue, ProjectLoggedHours, ProjectRoi, ProjectTotalCost } from '../../Services/reportingOverview';
import { convertCurrencyHelper } from '../../../../helpers/forexConvertor';
import typeOfContract from '../../../../constants/typeOfContract';

// Skeleton loader component for the table
const TableSkeletonLoader = ({ rows = 5 }) => {
    return (
        <div className="p-datatable p-component p-datatable-responsive-scroll">
            <div className="p-datatable-wrapper">
                <table
                    className="p-datatable-table"
                    style={{
                        minWidth: '50rem',
                        width: '100%',
                        textAlign: 'left',
                        borderSpacing: 0,
                    }}
                >
                    <thead className="p-datatable-thead">
                        <tr>
                            <th style={{ paddingRight: '44px', minWidth: '280px' }}>Client Name</th>
                            <th style={{ paddingRight: '44px' }}>Total Net Profit</th>
                            <th style={{ paddingRight: '44px' }}>Time Logged</th>
                            <th style={{ paddingRight: '44px' }}>Cost</th>
                            <th style={{ paddingRight: '44px' }}>ROI (%)</th>
                        </tr>
                    </thead>
                    <tbody className="p-datatable-tbody" style={{ marginBottom: 0, paddingBottom: 0 }}>
                        {Array.from({ length: rows }).map((_, index) => (
                            <tr key={`skeleton-${index}`}>
                                {/* Client Name */}
                                <td style={{ paddingRight: '44px', minWidth: '280px', paddingTop: '12px', paddingBottom: '12px', borderBottom: '1px solid #E5E7EB' }}>
                                    <div
                                        style={{
                                            width: '180px',
                                            height: '20px',
                                            backgroundColor: '#e5e7eb',
                                            borderRadius: '4px',
                                            animation: 'pulse 1.5s ease-in-out infinite',
                                        }}
                                    />
                                </td>
                                {/* Total Net Profit */}
                                <td style={{ paddingRight: '44px', paddingTop: '12px', paddingBottom: '12px', borderBottom: '1px solid #E5E7EB' }}>
                                    <div
                                        style={{
                                            width: '120px',
                                            height: '20px',
                                            backgroundColor: '#e5e7eb',
                                            borderRadius: '4px',
                                            animation: 'pulse 1.5s ease-in-out infinite',
                                        }}
                                    />
                                </td>
                                {/* Time Logged */}
                                <td className="fixed-sec4" style={{ paddingRight: '44px', paddingTop: '12px', paddingBottom: '12px', borderBottom: '1px solid #E5E7EB' }}>
                                    <div
                                        style={{
                                            width: '80px',
                                            height: '20px',
                                            backgroundColor: '#e5e7eb',
                                            borderRadius: '4px',
                                            animation: 'pulse 1.5s ease-in-out infinite',
                                        }}
                                    />
                                </td>
                                {/* Cost */}
                                <td style={{ paddingRight: '44px', paddingTop: '12px', paddingBottom: '12px', borderBottom: '1px solid #E5E7EB' }}>
                                    <div
                                        style={{
                                            width: '100px',
                                            height: '20px',
                                            backgroundColor: '#e5e7eb',
                                            borderRadius: '4px',
                                            animation: 'pulse 1.5s ease-in-out infinite',
                                        }}
                                    />
                                </td>
                                {/* ROI */}
                                <td style={{ paddingRight: '44px', paddingTop: '12px', paddingBottom: '12px', borderBottom: '1px solid #E5E7EB' }}>
                                    <div
                                        style={{
                                            width: '70px',
                                            height: '20px',
                                            backgroundColor: '#e5e7eb',
                                            borderRadius: '4px',
                                            animation: 'pulse 1.5s ease-in-out infinite',
                                        }}
                                    />
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
            <style>{`
                @keyframes pulse {
                    0%, 100% {
                        opacity: 1;
                    }
                    50% {
                        opacity: 0.5;
                    }
                }
            `}</style>
        </div>
    );
};

const CostPerClientOverview = ({ trackReport, projectCost, invoices, projects, sprints, expenses, clientLoading, clientError }) => {
    const reportingFinancialOverview = useSelector((state) => state.reportingFinancialOverview);
    const { forex } = useSelector((state) => state.forex);
    const settings = JSON.parse(localStorage.getItem("settings"));
    const [filteredData, setFilteredData] = useState([]);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [currentPage, setCurrentPage] = useState(0);

    // useEffect(() => {
    //     if (clients && reportingFinancialOverview) {
    //         const filtered = clients.filter(client =>
    //             !client.is_delete &&
    //             (reportingFinancialOverview.financialOverviewClient && reportingFinancialOverview.financialOverviewClient.includes(client._id)) &&
    //             (reportingFinancialOverview.financialOverviewYear && new Date(client.created_at).getFullYear() === reportingFinancialOverview.financialOverviewYear) &&
    //             (reportingFinancialOverview.financialOverviewCurrency && reportingFinancialOverview.financialOverviewCurrency.includes(client?.preferred_currency || 'USD'))
    //         );
    //         const sortedData = filtered.sort((a, b) => new Date(b.created_at) - new Date(a.created_at));
    //         setFilteredData(sortedData);
    //     }
    // }, [clients, reportingFinancialOverview]);
    // useEffect(() => {
    //     if (trackReport && reportingFinancialOverview) {
    //         const financialOverviewYear = reportingFinancialOverview.financialOverviewYear;

    //         const filteredClients = trackReport.filter((entry) => {
    //             const startTimeYear = new Date(entry.startTime).getFullYear();
    //             return startTimeYear === financialOverviewYear;
    //         });

    //         const uniqueClients = [];
    //         filteredClients.forEach((entry) => {
    //             const client = entry.clientId;
    //             if (
    //                 client &&
    //                 !client.is_delete &&
    //                 (reportingFinancialOverview.financialOverviewClient && reportingFinancialOverview.financialOverviewClient.includes(client._id)) &&
    //                 (reportingFinancialOverview.financialOverviewCurrency && reportingFinancialOverview.financialOverviewCurrency.includes(client?.preferred_currency || 'USD')) &&
    //                 !uniqueClients.some((c) => c._id === client._id)
    //             ) {
    //                 uniqueClients.push(client);
    //             }
    //         });

    //         const sortedData = uniqueClients.sort(
    //             (a, b) => new Date(b.created_at) - new Date(a.created_at)
    //         );

    //         setFilteredData(sortedData);
    //     }
    // }, [trackReport, reportingFinancialOverview]);

    useEffect(() => {
        // Validate input arrays
        if (!Array.isArray(trackReport)) trackReport = [];
        if (!Array.isArray(projectCost)) projectCost = [];
        if (!Array.isArray(invoices)) invoices = [];
        if (!Array.isArray(projects)) projects = [];
        if (!Array.isArray(sprints)) sprints = [];
        if (!Array.isArray(expenses)) expenses = [];

        if (trackReport.length > 0 && reportingFinancialOverview) {
            try {
                const financialOverviewYear = reportingFinancialOverview.financialOverviewYear || new Date().getFullYear();

                const filteredClients = trackReport.filter((entry) => {
                    if (!entry || !entry.startTime) return false;
                    const startTimeYear = new Date(entry.startTime).getFullYear();
                    return startTimeYear === financialOverviewYear;
                });

                const uniqueClients = [];
                filteredClients.forEach((entry) => {
                    if (!entry) return;
                    const client = entry.clientId;
                    if (
                        client &&
                        !client.is_delete &&
                        client._id &&
                        (reportingFinancialOverview.financialOverviewClient &&
                            reportingFinancialOverview.financialOverviewClient.includes(client._id)) &&
                        (reportingFinancialOverview.financialOverviewCurrency &&
                            reportingFinancialOverview.financialOverviewCurrency.includes(client?.preferred_currency || 'USD')) &&
                        !uniqueClients.some((c) => c && c._id === client._id)
                    ) {
                        uniqueClients.push(client);
                    }
                });

                const expenseClients = expenses
                    .filter(
                        (expense) => {
                            if (!expense || !expense.exp_date) return false;
                            return (
                                new Date(expense.exp_date).getFullYear() === financialOverviewYear &&
                                expense.exp_client &&
                                !expense.exp_client.is_delete &&
                                expense.exp_client._id &&
                                (reportingFinancialOverview.financialOverviewClient &&
                                    reportingFinancialOverview.financialOverviewClient.includes(expense.exp_client._id)) &&
                                (reportingFinancialOverview.financialOverviewCurrency &&
                                    reportingFinancialOverview.financialOverviewCurrency.includes(expense.exp_client?.preferred_currency || 'USD'))
                            );
                        }
                    )
                    .map((expense) => expense.exp_client)
                    .filter((client) => client && client._id); // Ensure client exists

                expenseClients.forEach((client) => {
                    if (client && client._id && !uniqueClients.some((c) => c && c._id === client._id)) {
                        uniqueClients.push(client);
                    }
                });

                const clientsWithMetrics = uniqueClients.map((client) => {
                    if (!client || !client._id) return null;

                    const clientTrackReport = trackReport.filter(
                        (entry) => {
                            if (!entry || !entry.startTime) return false;
                            return (
                                entry.clientId?._id === client._id &&
                                new Date(entry.startTime).getFullYear() === financialOverviewYear &&
                                (reportingFinancialOverview.financialOverviewClient &&
                                    reportingFinancialOverview.financialOverviewClient.includes(entry.clientId?._id)) &&
                                (reportingFinancialOverview.financialOverviewCurrency &&
                                    reportingFinancialOverview.financialOverviewCurrency.includes(entry.clientId?.preferred_currency || 'USD')) &&
                                !entry.clientId?.is_delete
                            );
                        }
                    );

                    const totalRevenue = clientRevenue(
                        clientTrackReport,
                        client._id,
                        projectCost,
                        invoices,
                        projects,
                        sprints,
                        reportingFinancialOverview,
                        settings?.currency || client?.preferred_currency || 'USD',
                        forex,
                        typeOfContract,
                        expenses
                    );

                    const totalCost = clientCost(
                        clientTrackReport,
                        client._id,
                        projectCost,
                        reportingFinancialOverview,
                        settings?.currency || client?.preferred_currency || 'USD',
                        forex,
                        typeOfContract,
                        expenses
                    );

                    const timeLogged = clientTrackReport.reduce((sum, entry) => {
                        return sum + (entry?.duration || 0);
                    }, 0);

                    const totalExpenses = expenses
                        .filter(
                            (expense) => {
                                if (!expense || !expense.exp_date) return false;
                                return (
                                    expense?.exp_client?._id === client._id &&
                                    new Date(expense.exp_date).getFullYear() === financialOverviewYear
                                );
                            }
                        )
                        .reduce(
                            (sum, expense) => {
                                if (!expense) return sum;
                                return sum + convertCurrencyHelper(
                                    expense.exp_currency || 'USD',
                                    client?.preferred_currency || 'USD',
                                    expense.exp_amount || 0,
                                    forex
                                );
                            },
                            0
                        );

                    const parsedRevenue = parseFloat(totalRevenue) || 0;
                    const parsedCost = parseFloat(totalCost) || 0;
                    const roi = parsedCost > 0 ? (parsedRevenue / parsedCost) * 100 : 0;

                    return {
                        ...client,
                        totalRevenue: parsedRevenue,
                        totalCost: parsedCost,
                        timeLogged: changeDurationFormat(timeLogged),
                        totalExpenses: parseFloat(totalExpenses) || 0,
                        roi: roi.toFixed(2),
                    };
                }).filter((client) => client !== null); // Remove null entries

                const sortedData = clientsWithMetrics.sort(
                    (a, b) => {
                        const dateA = a?.created_at ? new Date(a.created_at) : new Date(0);
                        const dateB = b?.created_at ? new Date(b.created_at) : new Date(0);
                        return dateB - dateA;
                    }
                );

                setFilteredData(sortedData);
            } catch (error) {
                console.error('Error processing client data:', error);
                setFilteredData([]);
            }
        } else {
            setFilteredData([]);
        }
    }, [trackReport, reportingFinancialOverview, projectCost, invoices, projects, sprints, expenses, forex, settings?.currency]);

    const changeDurationFormat = (sec) => {
        let second = sec;
        const hours = Math.floor(second / 3600);
        const minutes = Math.floor((second % 3600) / 60);
        const seconds = second % 60;
        const formattedDuration = `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
        return formattedDuration;
    }

    const onPageChange = (e) => {
        setCurrentPage(e.first / rowsPerPage);
    };

    if (clientLoading) {
        return (
            <div className="datatable-team-maintb">
                <TableSkeletonLoader rows={5} />
            </div>
        );
    }

    return (
        <div className="datatable-team-maintb">
            <DataTable
                value={filteredData}
                removableSort
                tableStyle={{
                    minWidth: "50rem",
                    width: "100%",
                    textAlign: "left",
                }}
                paginator={filteredData.length > rowsPerPage}
                paginatorClassName="recent-invoices-pagination"
                rows={rowsPerPage}
                first={currentPage * rowsPerPage}
                onPage={onPageChange}
                emptyMessage="No clients data found"
            >
                <Column
                    field="client_name"
                    // body={(rowData) => {
                    //     const clientName = rowData?.client_name || rowData?.legal_entity_name || 'Client Name';
                    //     return <TruncateFieldView textContent={clientName} />;
                    // }}
                    body={(rowData) => <ClientColumn rowData={rowData} />}
                    header="Client Name"
                    // className="fixed-sec3"
                    sortable
                    style={{ paddingRight: "44px", minWidth: "280px" }}
                ></Column>
                <Column
                    field="totalRevenue"
                    header="Total Net Profit"
                    sortable
                    body={(rowData) => new Intl.NumberFormat('en-US', {
                        style: 'currency',
                        currency: settings.currency
                    }).format(rowData.totalRevenue)}
                    style={{ paddingRight: '44px' }}
                />
                {/* <Column
                    field="total_revenue"
                    header="Total Net Profit"
                    body={ClientTotalRevenue}
                    sortable
                    style={{ paddingRight: '44px' }}
                /> */}
                <Column
                    field="timeLogged"
                    header="Time Logged"
                    className="fixed-sec4"
                    // sortable
                    style={{ paddingRight: "44px" }}
                ></Column>
                {/* <Column
                    field="tracked_hours"
                    header="Time Logged"
                    className="fixed-sec4"
                    body={ClientLoggedHours}
                    // sortable
                    style={{ paddingRight: "44px" }}
                ></Column> */}
                <Column
                    field="totalCost"
                    header="Cost"
                    style={{ paddingRight: "44px" }}
                    body={(rowData) => {
                        const cost = rowData?.totalCost || 0;
                        return new Intl.NumberFormat('en-US', {
                            style: 'currency',
                            currency: settings?.currency || 'USD'
                        }).format(cost);
                    }}
                />
                <Column
                    field="roi"
                    header="ROI (%)"
                    style={{ paddingRight: "44px" }}
                    body={(rowData) => {
                        const roi = rowData?.roi;
                        return roi ? `${roi}%` : "0.00%";
                    }}
                />
                {/* <Column
                    field="roi"
                    header="ROI"
                    body={ClientRoi}
                    // className="amount-bold"
                    // sortable
                    style={{ paddingRight: "44px" }}
                ></Column> */}
            </DataTable>
        </div>
    );
};

export default CostPerClientOverview;
